import { useEffect } from "react";
import { useMap } from "react-leaflet";

// Props type for the initializer component
interface MapInitializerProps {
    onMapReady: (map: L.Map) => void;
}

// Custom Hook to trigger logic when the map is ready
export const MapInitializer: React.FC<MapInitializerProps> = ({ onMapReady }) => {
    const map = useMap();

    useEffect(() => {
        if (map) {
            map.whenReady(() => {
                onMapReady(map);
            });
        }
    }, [map, onMapReady]);

    return null;
};
